import {
  Button,
  ButtonGroup,
  closeCurrentDialog,
  FormControl,
  FormButton,
  FormField,
} from 'platform/components';
import {VStack} from 'platform/foundation';

import i18n from '@dms/i18n';
import {useDocumentTemplates} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {RentVehicleFormValues} from '../types/RentVehicleFormValues';

interface SelectTemplateAndSubmitProps extends RequiredTestIdProps {
  control: FormControl<RentVehicleFormValues>;
  onSubmit: () => void;
}

export function SelectTemplateAndSubmit(props: SelectTemplateAndSubmitProps) {
  const [getTemplates] = useDocumentTemplates();

  const {options} = getTemplates('workshop-rental_order_contract');

  return (
    <VStack spacing={4}>
      <FormField
        control={props.control}
        type="choice"
        name="templateId"
        label={i18n.t('general.labels.template')}
        data-testid={suffixTestId('templateInformation', props)}
        options={options}
        isNotClearable
        menuInPortal
      />

      <ButtonGroup align="right">
        <Button
          variant="secondary"
          title={i18n.t('general.actions.close')}
          onClick={closeCurrentDialog}
        />

        <FormButton
          title={i18n.t('general.actions.confirm')}
          type="submit"
          control={props.control}
          onClick={() => {
            props.onSubmit();
            closeCurrentDialog();
          }}
        />
      </ButtonGroup>
    </VStack>
  );
}
